import {} from '../../../../../types/systemEvent'
import {
	CLINICAL_MSK_ACTION_TYPES,
	ClinicalMSKAction,
	ClinicalMSKState,
} from '../../../../../types/clinical'

const initialState: ClinicalMSKState = {
	carePlan: null,
	screeningTags: null,
}

export default (
	state = initialState,
	action: ClinicalMSKAction
): ClinicalMSKState => {
	switch (action.type) {
		case CLINICAL_MSK_ACTION_TYPES.GET_PATIENT_DATA: {
			return {
				...state,
				carePlan: action.payload.carePlan,
				screeningTags: action.payload.screeningTags,
			}
		}
		default: {
			return state
		}
	}
}
